var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"text-center justify-content-center h-75 align-items-center"},[_c('b-col',{attrs:{"cols":"6"}},[_c('h1',[_vm._v(" Schade... leider konnte die angeforderte Seite nicht gefunden werden ")])]),_c('b-col',{attrs:{"cols":"6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }